<script setup lang="ts">
import { IGenericUser } from '@/interfaces';
import DeactivatedBadge from './badges/DeactivatedBadge.vue';
import { computed } from 'vue';
import { AUTOMATIC_DELETION_DAYS } from 'common/constants/constant';
import { getDaysUntilDate } from 'common/utils/date.utils';
import ColorBadge from './badges/ColorBadge.vue';

const props = defineProps<{
  hideLabelWhenTooltip?: boolean;
  user: IGenericUser;
  size?: 'xs' | 'md';
}>();

const daysUntilDeletion = computed<number | null>(() => {
  if (!props.user.deactivatedAt) return null;
  const deactivationDate = new Date(props.user.deactivatedAt);
  const deletionDate = new Date(deactivationDate.getTime() + AUTOMATIC_DELETION_DAYS * 24 * 60 * 60 * 1000);
  return getDaysUntilDate(deletionDate);
});
</script>

<template>
  <DeactivatedBadge
    v-if="user.deactivatedAt"
    :hide-label-when-tooltip="hideLabelWhenTooltip"
    :size="props.size"
    class="shrink-0"
    :tooltip-text="$t('userStatus.deactivatedTitle', { count: daysUntilDeletion })"
  />
  <span v-else-if="user.isInvitation" class="flex items-center">
    <ColorBadge class="bg-surface-gray mr-sm" />
    {{ $t('user.table.invitationPendingShort') }}
  </span>
  <span v-else class="flex items-center">
    <ColorBadge class="bg-surface-green mr-sm" />
    {{ $t('user.table.active') }}
  </span>
</template>
